import { usePath } from '@arnold/common';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Redirect } from 'react-router-dom';
import { Topics } from '../../components/ConversationSubjects/Topics';
import { Features, TopicGroupTypeCode, UserQuery } from '../../generated/hooks';
import { useFeatureFlag } from '../../lib/helpers/hooks';
import { isPulserTopicGroup } from '../../lib/helpers/pulser';

interface IProps {
  user: UserQuery['user'];
}

const PulserTopicsScreen: FC<IProps> = ({ user }) => {
  const { t } = useTranslation('surveysOverview');
  const { pulserSurveysPath } = usePath();
  const hasPulserModule = useFeatureFlag(Features.PulserModule);

  if (!hasPulserModule) {
    return <Redirect to="/topics" />;
  }

  return (
    <Topics
      breadcrumbItems={[{ title: t('AuthorizedPage:pulser'), link: pulserSurveysPath.createPath() }]}
      heading={t('ReportAccess:topics')}
      dataIcom="heading-pulser-topics"
      user={user}
      filterTopicGroups={isPulserTopicGroup}
      createTopicTypeCode={TopicGroupTypeCode.Pulser}
    />
  );
};

export default PulserTopicsScreen;
